// Integration directory.
import {
    CreditCard,
    Landmark,
    ShoppingCart,
    FileSpreadsheet,
    MessageSquare,
    Mail,
    Cloud,
    Database,
    Webhook,
    Smartphone,
    Calendar,
    Wallet,
} from "lucide-react";

export const INTEGRATION_CATEGORIES = [
    {
        key: "pos",
        name: "POS & Retail",
        icon: ShoppingCart,
        intent: "Bring sales transactions straight into Mativex.",
        items: ["GoFrugal", "Petpooja", "Shopify POS", "Square", "Lightspeed", "Vend"],
    },
    {
        key: "accounting",
        name: "Accounting & ERP",
        icon: FileSpreadsheet,
        intent: "Sync with the system of record you already trust.",
        items: ["Tally", "Zoho Books", "QuickBooks", "Xero", "NetSuite", "SAP B1", "Odoo"],
    },
    {
        key: "banking",
        name: "Banking & Payments",
        icon: Landmark,
        intent: "Auto-import statements and reconcile in minutes.",
        items: ["HDFC", "ICICI", "Yes Bank", "Stripe", "Razorpay", "Plaid", "Open"],
    },
    {
        key: "cards",
        name: "Card & Wallet",
        icon: CreditCard,
        intent: "Reconcile online and offline payments without manual sheets.",
        items: ["Stripe", "Razorpay", "PayPal", "Adyen", "Paytm", "Mobikwik"],
    },
    {
        key: "comms",
        name: "Comms & Notifications",
        icon: MessageSquare,
        intent: "Push alerts and reminders where your team already is.",
        items: ["WhatsApp Business", "Slack", "Microsoft Teams", "Telegram", "SMS"],
    },
    {
        key: "email",
        name: "Email",
        icon: Mail,
        intent: "Send schedules, reports, and reminders from a verified domain.",
        items: ["Gmail / Workspace", "Outlook 365", "Resend", "SendGrid"],
    },
    {
        key: "cloud",
        name: "Cloud storage",
        icon: Cloud,
        intent: "Archive signed contracts and reports automatically.",
        items: ["Google Drive", "Dropbox", "OneDrive", "Box", "S3"],
    },
    {
        key: "calendar",
        name: "Calendar",
        icon: Calendar,
        intent: "Sync rosters, leaves, and meeting blocks.",
        items: ["Google Calendar", "Outlook Calendar", "Apple Calendar"],
    },
    {
        key: "data",
        name: "Data warehouse",
        icon: Database,
        intent: "Stream cleaned data to your warehouse for advanced analytics.",
        items: ["BigQuery", "Snowflake", "Redshift", "Postgres", "ClickHouse"],
    },
    {
        key: "wallet",
        name: "Payroll & wages",
        icon: Wallet,
        intent: "Disburse salaries and reimbursements without a separate vendor.",
        items: ["RazorpayX", "Stripe Connect", "Wise", "Bank disbursement APIs"],
    },
    {
        key: "mobile",
        name: "Mobile capture",
        icon: Smartphone,
        intent: "Field teams update progress, attendance, and costs from anywhere.",
        items: ["iOS app", "Android app", "Offline mode", "Geo-fencing"],
    },
    {
        key: "api",
        name: "API & webhooks",
        icon: Webhook,
        intent: "Build whatever isn't on this list — and let us know what to add next.",
        items: ["REST API", "Webhooks", "OAuth2", "Sandbox keys", "API docs"],
    },
];
